import React, { Suspense, lazy, Fragment } from "react";
import { Route, Routes } from "react-router-dom";
import Homepage from "./Components/Homepage/views/Homepage";
import Upload from "./Components/Upload/views/Upload";

const Fallback = <div className="loader-container"></div>;

const App = () => {
  return (
    <Fragment>
      <Suspense fallback={Fallback}>
        <Routes>
          <Route path="*" element={<Homepage />} />
          <Route path="events/:id" element={<Upload></Upload>} />
        </Routes>
      </Suspense>
    </Fragment>
  );
};

export default App;
